import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "components/ui/card";
import { ChartContainer, ChartTooltip, ChartTooltipContent, ChartConfig } from "components/ui/chart";
import AccountDetailLayout from "layout/account-detail-layout/AccountDetailLayout";
import Layout from "layout/layout";

import React, { useEffect, useState } from "react";
import { BarChart, Bar, PieChart, Pie, Cell, XAxis, YAxis, CartesianGrid, Label, LabelList } from "recharts";
// import ProfileOverview from "./accountDashboard/ProfileOverview";
import { RequestApi, RouteApi, RouteUrl, StatusMsg } from "utils";
import { useAppSelector } from "store/store";
import { AppLog } from "services";

import { TrendingUp } from "lucide-react";

import { follower, following, like, likes, love, post, shares } from "assets";
// import ImageUrl from "components/app/image-url/ImageUrl";
import ImageUrlProfile from "components/app/image-url/ImageUrlProfile";
import {
  // ShimmerAccountDashboard,
  ShimmerAccountDashboardTopPosts,
  ShimmerAccountDashboardTopPostsHeader,
  ShimmerAccoutOverView,
  ShimmerFollowByGender,
  ShimmerFollowersbyAge,
  ShimmerFollowersbyAudienceContents,
  ShimmerFollowersbyCountry,
  ShimmerFollowersbygrowthlast7days,
  ShimmerFollowersbyMCorn,
} from "components/app/shrimmer/Shrimmer";
import { Service } from "utils/services";
import DialogPostReaction from "components/app/dialog/DialogPostReaction";
import { PostReaction } from "models/postReaction";
import { useNavigate } from "react-router-dom";
import { setPost, setFollowByGender, setAudienceGrowth, setOverview, setOverviewReaction, setAudienceByAge, setFollowerByCountry } from "store/dashboardTopposts";
import { useDispatch } from "react-redux";

const COLORS = ["#2563eb", "#60a8fb", "#bedcfe"];
const COLORSCOUNTRY = ["#2563eb", "#60a8fb"];

export default function AccountDashbaord({ isRefresh = false }: { isRefresh?: boolean } = {}) {
  const { posts, followByGender, audienceGrowth, overview, overviewreaction, audienceByAge, fllowerByCountry } = useAppSelector((state) => state.topPosts);
  const dispatch = useDispatch();

  const { userAuth } = useAppSelector((state) => state.auth);
  const [gender, setGender] = useState<any[]>([]);
  const [accuountDashboard, setAccuountDashboard] = useState<any>();
  const [accuountDashboardLoading, setAccuountDashboardLoading] = useState<boolean>(false);
  const chartDataMCorn = [
    {
      browser: "Spending Amount",
      visitors: accuountDashboard?.spending_amount || 0,
      fill: "#2563eb",
    },
    {
      browser: "Earning Amount",
      visitors: accuountDashboard?.earning_amount || 0,
      fill: "#60a8fb",
    },
  ];

  const [dialogPostReaction, setDialogPostReaction] = useState({
    isOpen: false,
    post: null,
    postReaction: PostReaction.like,
  });

  const chartConfigMCorn = {
    chrome: {
      label: "Spending Amount",
      color: "hsl(var(--chart-1))",
    },
    safari: {
      label: "Earning Amount",
      color: "hsl(var(--chart-2))",
    },
  } satisfies ChartConfig;

  const getAccountDashboard = async () => {
    setAccuountDashboardLoading(true);
    try {
      const url = `${RouteApi.getAccountDashboard}token=${token}`;
      const response = await RequestApi(url);

      if (response.status === "success" && Array.isArray(response.records)) {
        dispatch(setFollowByGender(response.records));
        setGender(response.records);
        setAccuountDashboard(response);
        setAccuountDashboardLoading(false);
      } else {
        setGender([]); // Ensure it's an array
      }
    } catch (error) {
      setAccuountDashboardLoading(false);

      AppLog.show({
        message: `[getAccountDashboard]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  // const [followerByCountry, setFollowerByCountry] = useState<
  //   { location_country: string; followers: number }[]
  // >([]);
  const [loadingBycountry, setloadingBycountry] = useState<boolean>(false);
  // Fetch API Data
  const getAccountDashboardFollowerByCountry = async () => {
    setloadingBycountry(true);

    try {
      const url = `${RouteApi.getAccountDashboardFollowerByCountry}token=${token}`;
      const response = await RequestApi(url);

      if (response.status === "success" && Array.isArray(response.records)) {
        dispatch(setFollowerByCountry(response.records));
        // setFollowerByCountry(response.records);
        setloadingBycountry(false);
      } else {
        // setFollowerByCountry([]); // Handle empty response
      }
    } catch (error: any) {
      setloadingBycountry(false);

      console.error("API Error:", error);
    }
  };

  // Format Data for Chart
  const chartDataC = fllowerByCountry.map((item, index) => ({
    country: item.location_country, // Y-Axis Label
    followers: item.followers, // X-Axis Data
    fill: COLORSCOUNTRY[index % COLORSCOUNTRY.length],
  }));
  console.log("followerByCountry", fllowerByCountry);

  const totalVisitors = React.useMemo(() => {
    return followByGender.reduce((acc: number, curr: any) => acc + (curr.followers || 0), 0);
  }, []);

  const { token } = useAppSelector((state) => state.auth);
  const [apiResponse, setApiResponse] = useState<any>();
  const [loadingByAudienceGrowth, setloadingByAudienceGrowth] = useState<boolean>(false);

  const fetchAudienceGrowth = async () => {
    setloadingByAudienceGrowth(true);

    try {
      const url = `${RouteApi.getAccountDashboardAudienceGrowth}token=${token}`;
      const response = await RequestApi(url);

      if (response.status === "success") {
        dispatch(setAudienceGrowth(response.records));

        setApiResponse(response.records);
        setloadingByAudienceGrowth(false);
      }
    } catch (error: any) {
      setloadingByAudienceGrowth(false);

      console.error("API Error:", error);
    }
  };

  // ----------------By age--------------------
  // const [audienceByAge, setAudienceByAge] = useState<any>();
  const [loadingAudienceGrowthByAge, setloadingAudienceGrowthByAge] = useState<boolean>(false);

  const getAccountDashboardAudienceGrowthByAge = async () => {
    setloadingAudienceGrowthByAge(true);
    try {
      const url = `${RouteApi.getAccountDashboardAudienceGrowthByAge}token=${token}`;
      const response = await RequestApi(url);

      if (response.status === "success") {
        setloadingAudienceGrowthByAge(false);
        dispatch(setAudienceByAge(response.records));

        // setAudienceByAge(response.records); // Ensure it's an array
      }
    } catch (error: any) {
      setloadingAudienceGrowthByAge(false);

      console.error("API Error:", error);
    }
  };

  const [accountreactions, setaccountreactions] = useState<any>();
  const [loadingAccountOverView, setLoadingAccountOverView] = useState<boolean>(false);
  const [accountOverview, setaccountOverview] = useState<any>();
  const [accountreachs, setaccountreachs] = useState<any>();

  const getAccountDashboardOverview = async () => {
    setLoadingAccountOverView(true);
    try {
      const url = `${RouteApi.getAccountDashboardOverview}token=${token}`;
      const response = await RequestApi(url);
      dispatch(setOverview(response.reactions));
      dispatch(setOverviewReaction(response.views));

      setaccountreactions(response.reactions);
      setaccountOverview(response.views);
      setaccountreachs(response.reachs);
      setLoadingAccountOverView(false);
    } catch (error) {
      setLoadingAccountOverView(false);
      console.error("API Error:", error);
    }
  };
  const formatWatchTime = (seconds: any) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;

    return `${h > 0 ? `${h}h ` : ""}${m > 0 ? `${m}m ` : ""}${s > 0 ? `${s}s` : ""}`.trim();
  };
  const formatViews = (num: any) => {
    if (num >= 1_000_000) {
      return (num / 1_000_000).toFixed(1) + "M"; // Convert to millions
    } else if (num >= 1_000) {
      return (num / 1_000).toFixed(1) + "K"; // Convert to thousands
    }
    return num; // Return as-is if below 1K
  };
  const reachData = accountreachs?.map((item: any) => item.no_of_view_count);

  const [loadingByTopPostChart, setloadingByTopPostChart] = useState<boolean>(false);
  const getAccountDashboardTopPostChart = async () => {
    setloadingByTopPostChart(true);
    try {
      const url = `${RouteApi.getAccountDashboardTopPostChart}token=${token}`;
      const response = await RequestApi(url);
      if (response.status === "success") {
        const tmpPosts = isRefresh ? [...response["posts"]] : [...posts, ...response["posts"]];

        dispatch(setPost(tmpPosts));
      }
      setloadingByTopPostChart(false);

      // setAccountDashboardTopPostChart(response.posts);
    } catch (error) {
      setloadingByTopPostChart(false);

      console.error("API Error:", error);
    }
  };

  const onOpenReactionDialog = (post: any, postReaction: PostReaction) => {
    try {
      setDialogPostReaction({
        isOpen: true,
        post: post,
        postReaction,
      });
    } catch (error) {
      AppLog.show({
        message: `[onOpenReactionDialog]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (posts.length === 0) {
      getAccountDashboardTopPostChart();
    }
    if (followByGender.length === 0) {
      getAccountDashboard();
    }
    if (audienceGrowth.length === 0) {
      fetchAudienceGrowth();
    }
    if (overview.length === 0 && overviewreaction.length === 0) {
      getAccountDashboardOverview();
    }
    if (audienceByAge.length === 0) {
      getAccountDashboardAudienceGrowthByAge();
    }
    if (fllowerByCountry.length === 0) {
      getAccountDashboardFollowerByCountry();
    }
  }, []);
  const navigate = useNavigate();
  const onGoToPost = (postId: string) => {
    navigate(`${RouteUrl.profilePostContentsPageView}?post_id=${postId}`, {
      state: { data: { isBackNavigation: true } },
    });
  };
  const postContents = (post: any) => {
    if (post.media_type?.toLowerCase() === "photo" || post.media_type?.toLowerCase() === "album") {
      const width = Service.toDouble(post?.post_attachments[0].attachment_media_width);
      const height = Service.toDouble(post?.post_attachments[0].attachment_media_height);
      const ratio = height === 0 ? 1 : width / height;

      return (
        <div className="flex w-full h-full relative overflow-hidden  pointer-events-none rounded-lg  cursor-pointer">
          <div
            className="absolute inset-0 bg-cover bg-center bg-black opacity-50 blur-3xl  cursor-pointer"
            style={{
              backgroundImage: `url("${post?.post_attachments[0]?.attachment_thumbnail_image_file_src}")`,
            }}
          />
          <img
            // onClick={() => onGoToPost(post.provider_post_id)}
            style={{ cursor: "pointer" }}
            src={post.post_attachments[0].attachment_media_image_file_src}
            alt="Post"
            className={`relative z-10  w-full h-auto rounded-lg cursor-pointer   ${ratio >= 0 && ratio < 0.74 ? "object-cover rounded-lg" : "object-contain rounded-lg"}`}
            loading="lazy"
          />
        </div>
      );
    } else if (post.media_type?.toLowerCase() === "video") {
      const width = Service.toDouble(post?.post_attachments[0].attachment_media_width);
      const height = Service.toDouble(post?.post_attachments[0].attachment_media_height);
      const ratio = height === 0 ? 1 : width / height;

      return (
        <div className="flex w-full h-full relative overflow-hidden  pointer-events-none rounded-lg  cursor-pointer">
          <div
            className="absolute inset-0 bg-cover bg-center bg-black opacity-50 blur-3xl  cursor-pointer"
            style={{
              backgroundImage: `url("${post?.post_attachments[0]?.attachment_thumbnail_image_file_src}")`,
            }}
          />

          <img
            onClick={() => onGoToPost(post.provider_post_id)}
            style={{ cursor: "pointer" }}
            src={post.post_attachments[0].attachment_thumbnail_image_file_src}
            alt="Post"
            className={`relative z-10  w-full h-auto rounded-lg  cursor-pointer ${ratio >= 0 && ratio < 0.74 ? "object-cover rounded-lg" : "object-contain rounded-lg"}`}
            loading="lazy"
          />
        </div>
      );
    } else {
      return <div>Content Not Found! {post.media_type}</div>;
    }
  };

  return (
    <>
      <AccountDetailLayout>
        <div className="min-h-[calc(100vh-120px)] space-y-4 mb-14">
          <div className="flex justify-between">
            <div>
              <h1 className="font-semibold lg:text-lg md:text-md sm:text-sm">Dashboard</h1>
              <div className="space-y-2 text-muted-foreground">
                <div>
                  <span className="text-muted-foreground font-semibold lg:text-md md:text-sm text-[13px]">Track Engagement, Growth, and Performance in One Place</span>
                </div>
              </div>
            </div>
          </div>
          {accuountDashboardLoading && loadingAudienceGrowthByAge ? (
            <>
              {" "}
              <div className="grid grid-cols-1 xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-2 gap-2 h-[300px] overflow-hidden">
                <ShimmerFollowByGender />
                <ShimmerFollowersbyAge />
                <ShimmerFollowersbyMCorn />
              </div>
            </>
          ) : (
            <>
              <div className="grid grid-cols-1 xl:grid-4 lg:grid-cols-4 md:grid-cols-3 gap-2 h-[300px] overflow-hidden">
                <Card className="flex flex-col justify-center">
                  <CardContent className="flex-1 pb-0">
                    <ChartContainer config={{}} className="mx-auto aspect-square max-h-[250px]">
                      <PieChart>
                        <ChartTooltip cursor={false} content={<ChartTooltipContent hideLabel />} />
                        <Pie
                          data={followByGender}
                          dataKey="followers"
                          nameKey="gender"
                          innerRadius={60}
                          strokeWidth={5}
                          // fill=""
                        >
                          {followByGender.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                          ))}

                          <Label
                            content={({ viewBox }) => {
                              if (viewBox && "cx" in viewBox && "cy" in viewBox) {
                                return (
                                  <text x={viewBox.cx} y={viewBox.cy} textAnchor="middle" dominantBaseline="middle">
                                    <tspan x={viewBox.cx} y={viewBox.cy} className="fill-foreground text-3xl font-bold">
                                      {totalVisitors}
                                    </tspan>
                                    <tspan x={viewBox.cx} y={(viewBox.cy || 0) + 24} className="fill-muted-foreground text-lg">
                                      Followers
                                    </tspan>
                                  </text>
                                );
                              }
                            }}
                          />
                        </Pie>
                      </PieChart>
                    </ChartContainer>
                  </CardContent>
                  <CardFooter className="flex-col gap-2 text-sm md:text-[12px]">
                    <div className="flex items-center gap-2 font-medium leading-none">
                      2025 active followers
                      <TrendingUp className="h-4 w-4" />
                    </div>
                  </CardFooter>
                </Card>
                <Card className="lg:col-span-2">
                  <CardHeader>
                    <CardTitle className="font-semibold text-sm">Active followers by age</CardTitle>
                  </CardHeader>

                  <CardContent
                    className="h-[230px] flex items-center justify-center p-0"
                    style={{
                      paddingBottom: 0,
                    }}
                  >
                    <ChartContainer className="h-[230px]" config={{}}>
                      <BarChart className="h-[230px] " accessibilityLayer data={audienceByAge}>
                        <CartesianGrid vertical={false} />
                        <XAxis dataKey="Age" tickLine={false} tickMargin={0} axisLine={false} />
                        <ChartTooltip cursor={false} content={<ChartTooltipContent indicator="dashed" />} />
                        <Bar dataKey="Male" fill="#2563eb" radius={4} className="" />
                        <Bar dataKey="Female" fill="#60a8fb" radius={4} />
                      </BarChart>
                    </ChartContainer>
                  </CardContent>
                </Card>

                {/* ----------M Corn-------- */}
                <Card className="flex flex-col justify-center">
                  <CardContent className="flex-1 pb-0">
                    <ChartContainer config={chartConfigMCorn} className="mx-auto aspect-square max-h-[250px]">
                      <PieChart>
                        <ChartTooltip cursor={false} content={<ChartTooltipContent hideLabel />} />
                        <Pie data={chartDataMCorn} dataKey="visitors" nameKey="browser" innerRadius={60} strokeWidth={5}>
                          <Label
                            content={({ viewBox }) => {
                              if (viewBox && "cx" in viewBox && "cy" in viewBox) {
                                return (
                                  <text x={viewBox.cx} y={viewBox.cy} textAnchor="middle" dominantBaseline="middle">
                                    <tspan x={viewBox.cx} y={viewBox.cy} className="fill-foreground text-3xl font-bold">
                                      {accuountDashboard.total_corn_amount}
                                    </tspan>
                                    <tspan x={viewBox.cx} y={(viewBox.cy || 0) + 24} className="fill-muted-foreground">
                                      M Corn
                                    </tspan>
                                  </text>
                                );
                              }
                            }}
                          />
                        </Pie>
                      </PieChart>
                    </ChartContainer>
                  </CardContent>
                  <CardFooter className="flex-col gap-2 text-sm md:text-[12px]">
                    <div className="flex items-center gap-2 font-medium leading-none">
                      Your earning corn from FlipFlop
                      {/* <TrendingUp className="h-4 w-4" /> */}
                    </div>
                  </CardFooter>
                </Card>
              </div>
            </>
          )}
          {loadingBycountry && loadingByAudienceGrowth ? (
            <>
              <div className="grid grid-cols-1 xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-2 gap-2 h-[300px] overflow-hidden">
                <ShimmerFollowersbyCountry />
                <ShimmerFollowersbygrowthlast7days />
                <ShimmerFollowersbyAudienceContents />
              </div>
            </>
          ) : (
            <>
              <div className="grid grid-cols-1 xl:grid-4 lg:grid-cols-4 md:grid-cols-3 gap-2 h-[300px] overflow-hidden">
                <Card className=" ">
                  <CardHeader>
                    <CardTitle className="font-semibold text-sm">Top active followers by country</CardTitle>
                  </CardHeader>
                  <CardContent className="pb-0">
                    <ChartContainer config={{}}>
                      <BarChart className="" accessibilityLayer data={chartDataC} layout="vertical">
                        <CartesianGrid horizontal={false} />
                        <YAxis className="" dataKey="country" type="category" tickLine={false} tickMargin={10} axisLine={false} tickFormatter={(value) => value.slice(0, 3)} hide />
                        <XAxis dataKey="followers" type="number" hide />
                        <ChartTooltip cursor={false} content={<ChartTooltipContent indicator="line" />} />
                        <Bar dataKey="followers" layout="vertical" fill="var(--color-desktop)" radius={4}>
                          <LabelList
                            dataKey="country"
                            position="insideLeft"
                            offset={8}
                            // className="text-[#ffffff]"
                            fill="dark:#ffffff"
                            fontSize={12}
                          />
                        </Bar>
                      </BarChart>
                    </ChartContainer>
                  </CardContent>
                </Card>
                <Card className="lg:col-span-2">
                  <CardHeader>
                    <CardTitle className="font-semibold text-sm">Audience reach growth last 7 days</CardTitle>
                  </CardHeader>
                  <CardContent
                    className="h-[230px] flex items-center justify-center p-0"
                    style={{
                      paddingBottom: 0,
                    }}
                  >
                    <ChartContainer className="h-[230px]" config={{}}>
                      <BarChart className="h-[230px]" accessibilityLayer data={audienceGrowth}>
                        <CartesianGrid vertical={false} />
                        <XAxis dataKey="date" tickLine={false} tickMargin={10} axisLine={false} />
                        <ChartTooltip cursor={false} content={<ChartTooltipContent indicator="dashed" />} />
                        <Bar dataKey="Male" fill="#2563eb" radius={4} />
                        <Bar dataKey="Female" fill="#60a8fb" radius={4} />
                      </BarChart>
                    </ChartContainer>
                  </CardContent>
                </Card>
                <Card className="">
                  <CardHeader>
                    <CardTitle className="font-semibold text-sm">Audience & Contents</CardTitle>
                  </CardHeader>
                  <CardContent
                    className="h-[230px] p-0 "
                    style={{
                      paddingBottom: 0,
                    }}
                  >
                    <div className="grid grid-cols-1 h-full p-0 px-[20px] mb-5">
                      <div className=" grid grid-cols-2 ">
                        <div className=" flex flex-col items-center ">
                          <div className=" rounded-full  flex items-center justify-center">
                            <img src={follower} className="lg:w-[50px] lg:h-[50px] md:w-[40px] rounded-full" alt="logo" />
                          </div>
                          <span className="text-sm">{userAuth?.no_of_follower} followers</span>
                        </div>
                        <div className=" flex flex-col items-center">
                          <div className="lg:w-[50px] lg:h-[50px] md:w-[40px] rounded-full  flex items-center justify-center   ">
                            <img src={following} className=" w-full h-full object-cover " alt="logo" />
                          </div>
                          <span className="text-sm">{userAuth?.no_of_following} Following</span>
                        </div>
                      </div>
                      <div className=" grid grid-cols-2">
                        <div className=" flex flex-col items-center">
                          <div className=" rounded-full flex items-center justify-center ">
                            <img src={post} className="lg:w-[50px] lg:h-[50px] md:w-[40px] rounded-full" alt="logo" />
                          </div>
                          <span className="text-sm">{userAuth?.no_of_post} Posts</span>
                        </div>
                        <div className=" flex flex-col items-center">
                          <div className=" rounded-full   flex items-center justify-center text-white ">
                            <img src={love} className="lg:w-[50px] lg:h-[50px] md:w-[40px] rounded-full " alt="logo" />
                          </div>
                          <span className="text-sm"> {userAuth?.no_of_like} Loves</span>
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </div>
            </>
          )}
          {loadingByTopPostChart ? (
            <ShimmerAccountDashboardTopPostsHeader />
          ) : (
            <div className="flex items-center px-[20px]">
              <h1 className="font-semibold text-xl">Top 6 Posts Reach</h1>
            </div>
          )}

          <div className="grid grid-cols-1 xl:grid-4 lg:grid-cols-4 md:grid-cols-2 gap-2">
            {loadingByTopPostChart ? (
              <>
                <ShimmerAccountDashboardTopPosts />
              </>
            ) : (
              <div className="col-span-3 row-span-2 ">
                <div className="grid grid-cols-1 lg:grid-cols-2 md:grid-cols-1 gap-2">
                  {posts?.map((item: any, index: any) => {
                    return (
                      <Card key={index} className="overflow-hidden p-2  h-[418px] flex flex-row justify-between">
                        <div onClick={() => onGoToPost(item.provider_post_id)} className="flex aspect-[9/16] cursor-pointer">
                          {postContents(item)}
                        </div>
                        <div className="flex flex-1 pl-5  flex-col justify-start">
                          <p key={index} className="text-md line-clamp-2 h-[50px]">
                            {item.media_title}
                          </p>
                          <span className="text-lg font-semibold mt-5">{item.reaction_score} Scroe</span>
                          <div className="flex flex-col justify-start w-full gap-2 mt-5 ">
                            <div className=" font-medium text-muted-foreground pt-1 flex flex-col  justify-start h-[60px]">
                              <span className="text-sm ">
                                <span className=" cursor-pointer" onClick={() => onOpenReactionDialog(item, PostReaction.comment)}>
                                  {item.comment_count} Comment
                                </span>
                              </span>
                              <div className="flex justify-start -space-x-4 rtl:space-x-reverse">
                                {item?.comment_users?.map((item: any, index: any) => {
                                  return (
                                    <div key={index}>
                                      <ImageUrlProfile
                                        isLinkProfile={true}
                                        className="w-8 h-8 border-2 border-white rounded-full dark:border-gray-800"
                                        user={item}
                                        alt="User avatar"
                                      />
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                            <div className=" font-medium text-muted-foreground pt-1 flex flex-col justify-start h-[60px]">
                              <span className="text-sm">
                                <span className=" cursor-pointer hover:border-1 border-gray-500" onClick={() => onOpenReactionDialog(item, PostReaction.share)}>
                                  {item.reaction_share_count} Shared
                                </span>
                              </span>
                              <div className="flex justify-start -space-x-4 rtl:space-x-reverse ">
                                {item.share_users?.map((item: any, index: any) => {
                                  return (
                                    <div key={index}>
                                      <ImageUrlProfile
                                        isLinkProfile={true}
                                        className="w-8 h-8 border-2 border-white rounded-full dark:border-gray-800"
                                        user={item}
                                        alt="User avatar"
                                      />
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                            <div className=" font-medium text-muted-foreground pt-1 flex flex-col justify-start h-[60px]">
                              <span className="text-sm">
                                <span className=" cursor-pointer hover:border-1 border-gray-500" onClick={() => onOpenReactionDialog(item, PostReaction.like)}>
                                  {item.reaction_like_count} Likes
                                </span>
                              </span>
                              <div className="flex justify-start -space-x-4 rtl:space-x-reverse">
                                {item.like_users?.map((item: any, index: any) => {
                                  return (
                                    <div key={index}>
                                      <ImageUrlProfile
                                        isLinkProfile={true}
                                        className="w-8 h-8 border-2 border-white rounded-full dark:border-gray-800"
                                        user={item}
                                        alt="User avatar"
                                      />
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                            <div className=" font-medium text-muted-foreground pt-1 flex flex-col  justify-start h-[60px]">
                              <span className="text-sm">
                                <span className=" cursor-pointer" onClick={() => onOpenReactionDialog(item, PostReaction.view)}>
                                  {item.reach_count} Reachs
                                </span>
                              </span>
                              <div className="flex justify-start -space-x-4 rtl:space-x-reverse">
                                {item.reach_users?.map((item: any, index: any) => {
                                  return (
                                    <div key={index}>
                                      <ImageUrlProfile
                                        isLinkProfile={true}
                                        className="w-8 h-8 border-2 border-white rounded-full dark:border-gray-800"
                                        user={item}
                                        alt="User avatar"
                                      />
                                    </div>
                                  );
                                })}
                                {/* {item?.reach_count > 3 ? (
                                    <p className="flex items-center justify-center w-8 h-8 text-xs font-medium text-white bg-gray-700 border-2 border-white rounded-full hover:bg-gray-600 dark:border-gray-800">
                                      +
                                      {Service.abbreviateNumber(
                                        item.reach_count - 3
                                      )}
                                    </p>
                                  ) : (
                                    <></>
                                  )} */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </Card>
                    );
                  })}
                </div>
              </div>
            )}

            {loadingAccountOverView ? (
              <>
                <ShimmerAccoutOverView />
              </>
            ) : (
              <Card className="h-[418px]">
                <div className="">
                  <div className="px-4 pb-4">
                    <div className="">
                      <h3 className="text-sm font-semibold mt-5"> Last 7 days viewers</h3>
                      <div className="space-y-2">
                        {overviewreaction?.map((item: any, index: any) => (
                          <>
                            <div key={index} className="">
                              <div className="flex justify-between items-center text-sm  border-b-2 gap-2 pb-2">
                                <span className="flex items-center gap-1 text-gray-700 dark:text-gray-400 mt-4">Views</span>
                                <span className="font-semibold mt-4">{formatViews(item.viewers)}</span>
                              </div>
                              <div className="flex justify-between items-center text-sm  border-b-2 gap-2 pb-2">
                                <span className="flex items-center gap-1 text-gray-700 dark:text-gray-400 mt-4">3-second views</span>
                                <span className="font-semibold mt-4">{formatViews(item["3_second_viewers"])}</span>
                              </div>
                              <div className="flex justify-between items-center text-sm  border-b-2 gap-2 pb-2">
                                <span className="flex items-center gap-1 text-gray-700 dark:text-gray-400 mt-4">1-minute views</span>
                                <span className="font-semibold mt-4">{formatViews(item["60_second_viewers"])}</span>
                              </div>
                              <div className="flex justify-between items-center text-sm  border-b-2 gap-2 pb-2">
                                <span className="flex items-center gap-1 text-gray-700 dark:text-gray-400 mt-4">Reachs</span>
                                <span className="font-semibold mt-4">{formatWatchTime(item.watch_time)}</span>
                              </div>
                              <div className="flex justify-between items-center text-sm  border-b-2 gap-2 pb-2">
                                <span className="flex items-center gap-1 text-gray-700 dark:text-gray-400 mt-4">Reachs</span>
                                <span className="font-semibold mt-4">{formatViews(reachData)}</span>
                              </div>
                            </div>
                          </>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                {overview?.map((item: any, index: number) => {
                  return (
                    <div key={index}>
                      <h3 className="text-sm font-semibold px-[20px]">Last 7 days interactions</h3>
                      <div key={index} className="flex justify-between items-start w-full lg:px-5 px-1 mb-5 mt-4">
                        <div className="flex flex-col items-center justify-start">
                          <img className="w-[50px] h-[50px]" src={likes} alt="" />
                          <span className="pt-1 text-gray-700 dark:text-gray-400 text-sm">
                            <span className="font-semibold mt-4 pe-1">{Service.abbreviateNumber(item.no_of_favorite)}</span>
                            Favuorites
                          </span>
                        </div>
                        <div className="flex flex-col items-center">
                          <img className="w-[50px] h-[50px]" src={like} alt="" />
                          <span className="pt-1 text-gray-700 dark:text-gray-400 text-sm">
                            <span className="font-semibold mt-4 pe-1">{Service.abbreviateNumber(item.no_of_like)}</span>
                            Likes
                          </span>
                        </div>
                        <div className="flex flex-col items-center">
                          <img className="w-[50px] h-[50px]" src={shares} alt="" />
                          <span className="pt-1 text-gray-700 dark:text-gray-400 text-sm">
                            <span className="font-semibold mt-4 pe-1">{Service.abbreviateNumber(item.no_of_share)}</span>
                            Shared
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </Card>
            )}
          </div>
        </div>
      </AccountDetailLayout>

      {dialogPostReaction.isOpen && (
        <DialogPostReaction
          post={dialogPostReaction.post}
          isDialogOpen={dialogPostReaction.isOpen}
          postReaction={dialogPostReaction.postReaction}
          setIsDialogOpen={(isOpen) => setDialogPostReaction({ ...dialogPostReaction, isOpen })}
        />
      )}
    </>
  );
}
